module.exports = "/assets/4e04d157c1ffc3cf608eb7c5bddfb44e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/7C.png
// module id = 2236
// module chunks = 0